import {InjectionToken, Provider} from '@angular/core';
import {Observable, of} from 'rxjs';

export const MEDIA_GALLERY_SERVER_SIDE_RENDERED = new InjectionToken<Observable<boolean>>(
  'MEDIA_GALLERY_SERVER_SIDE_RENDERED'
);

export const MEDIA_GALLERY_PROVIDERS: Provider[] = [
];
